import { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
import { Link } from "react-router-dom";
import BaseLayout from "../../layout/BaseLayout";
import "./recharge.css";

// icons
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  getListeForfaits_allRight,
  getListeForfaits_secure,
} from "../../services/forfait/ForfaitRequest";

import BANNER from "./../../assets/images/banner.png";

const ForfaitAccueil = () => {
  const [listeForfaits, setListeForfaits] = useState([]);

  useEffect(() => {
    try {
      if (sessionStorage.getItem("token")) {
        getListeForfaits_secure()
          .then((res) => {
            setListeForfaits(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      } else {
        getListeForfaits_allRight()
          .then((res) => {
            setListeForfaits(res.data.donnee);
          })
          .catch((err) => {
            console.log("api error", err);
          });
      }
    } catch (error) {
      console.log("catch error", error);
    }
  }, []);

  return (
    <BaseLayout>
      <div className="header relative w-full h-fit pb-16 bg-jaune-mtn">
        <div className="z-10 absolute bottom-0 left-0 right-0 bg-gray-mtn w-full">
          <svg
            height="19px"
            viewBox="0 0 1366 19.18"
            preserveAspectRatio="none"
            className="w-full hidden sm:block bg-jaune-mtn"
          >
            <path
              d="M683.1,18.3C386.63,18.3,129.24,10.85,0,0V19.18H1366V0C1236.66,10.84,979.37,18.3,683.1,18.3Z"
              fill="#f2F2f2"
            ></path>
          </svg>
          <svg
            viewBox="0 0 500 40"
            preserveAspectRatio="xMidYMin meet"
            className="w-full block sm:hidden bg-gray-mtn"
          >
            <path d="M0,0 Q250,80 500,0 Z" fill="#ffcc02"></path>
          </svg>
        </div>

        <div className="w-11/12 md:w-10/12 lg:w-10/12 xl:w-9/12 mx-auto flex pt-10 sm:pt-16">
          <div>
            <img src={BANNER} alt="promo mtn" className="w-screen h-32 object-cover border" />
          </div>

          <div></div>
        </div>
      </div>

      <div className="w-full bg-gray-mtn pt-20 mb-16">
        {/* <div className="w-11/12 md:w-11/12 lg:w-11/12 xl:w-9/12 mx-auto flex flex-wrap lg:flex-nowrap gap-y-4 items-center justify-between">
          <p className="text-2xl font-medium">
            Customise your <span className="font-bold">Fixed LTE</span> plan
            below
          </p>

          <div className="flex flex-wrap sm:flex-nowrap gap-y-4 items-center gap-x-4">
            <div className="btn-group bg-white w-48 sm:w-60 xl:w-72 h-10 sm:h-12 rounded-xl border-2 border-black">
              <button
                style={!productType ? { backgroundColor: "#ffcc02" } : {}}
                className="w-1/2 font-bold h-full rounded-tl-xl rounded-bl-xl outline-none text-xs sm:text-base ring-none border-none"
                onClick={choosePrePaid}
              >
                Pre-paid
              </button>
              <button
                style={productType ? { backgroundColor: "#ffcc02" } : {}}
                className="w-1/2 h-full font-bold rounded-tr-xl rounded-br-xl outline-none text-xs sm:text-base"
                onClick={choosePostPaid}
              >
                Post-paid
              </button>
            </div>

            <div className="btn-group bg-white w-48 sm:w-60 xl:w-72 h-10 sm:h-12 rounded-xl border-2 border-black">
              <button
                style={!serviceType ? { backgroundColor: "#ffcc02" } : {}}
                className="w-1/2 text-xs sm:text-base font-bold h-full rounded-tl-xl rounded-bl-xl outline-none ring-none border-none px-2"
                onClick={chooseServiceSimDevice}
              >
                Sim & Device
              </button>
              <button
                style={serviceType ? { backgroundColor: "#ffcc02" } : {}}
                className="w-1/2 h-full text-xs sm:text-base font-bold rounded-tr-xl rounded-br-xl outline-none ring-none border-none"
                onClick={chooseServiceSim}
              >
                Sim only
              </button>
            </div>
          </div>
        </div> */}
        <div className="w-11/12 md:w-11/12 lg:w-11/12 xl:w-9/12 mx-auto flex flex-wrap lg:flex-nowrap gap-y-4 items-center justify-between">
          <p className="text-2xl font-medium">Liste des forfaits</p>
        </div>

        <div className="w-11/12 xl:w-9/12 mx-auto divider"></div>

        {/* PRODUCTS FOR DESKTOP */}
        <div className="w-11/12 xl:w-9/12 mx-auto hidden sm:grid grid-cols-2 justify-items-center lg:grid-cols-3 gap-y-8 sm:gap-x-4 mt-10 pb-16">
          {listeForfaits.length > 0 ? (
            listeForfaits.map((item, index) => (
              <Link
                to={`/detail-forfait/${item.id}`}
                className="block"
                key={index}
              >
                <div className="w-[19rem] md:w-80 bg-gray-100 border-4 border-white rounded-2xl h-20 flex items-center shadow-xl">
                  <div className="w-1/3 px-5 h-full rounded-tl-xl rounded-bl-xl flex flex-col items-center justify-center bg-jaune-mtn">
                    <p className="text-black text-xl font-bold">
                      {item.volume}
                      {item.unite}
                    </p>
                    <p className="text-xs text-center italic leading-3">
                      {item.designation}
                    </p>
                  </div>
                  <div className="w-2/3 h-full rounded-2xl flex items-center justify-between gap-x-6 bg-transparent p-3">
                    <div>
                      <p className="text-black text-center text-xl font-bold leading-5">
                        {item.cout}
                        <span className="text-sm">FCFA</span>
                      </p>
                    </div>
                    <div className="bg-jaune-mtn w-10 h-10 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                      <KeyboardArrowRightIcon />
                    </div>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <>
              <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="6rem" borderRadius="1rem"></Skeleton>
            </>
          )}
        </div>

        {/* PRODUCTS FOR MOBILE */}
        <div className="list-forfait w-11/12 mx-auto mt-10 sm:hidden grid grid-cols-2 gap-y-8 gap-x-2 pb-16 justify-items-center">
          {listeForfaits.length > 0 ? (
            listeForfaits.map((item, index) => (
              <Link to={`/detail-forfait/${item.id}`} key={index}>
                <div className="w-full rounded-xl shadow-lg border-4 border-white">
                  <div className="bg-jaune-mtn rounded-tl-xl rounded-tr-xl py-3">
                    <p className="text-black text-2xl text-center font-bold">
                      {item.volume} {item.unite}
                    </p>
                    <p className="text-xs text-center italic leading-3">
                      {item.designation}
                    </p>
                  </div>
                  <div className="bg-transparent rounded-tl-xl rounded-tr-xl flex items-center justify-between px-5 py-3">
                    <div>
                      <p className="text-black text-lg text-center font-bold">
                        {item.cout}
                        <span className="text-xs">FCFA</span>
                      </p>
                    </div>

                    <div className="bg-jaune-mtn w-7 h-7 rounded-full flex items-center justify-center ml-4 cursor-pointer">
                      <KeyboardArrowRightIcon />
                    </div>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <>
              <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
              <Skeleton height="5rem" borderRadius="1rem"></Skeleton>
            </>
          )}
        </div>
      </div>

      {/* <div className="mt-10 pb-16 w-11/12 md:w-9/12 mx-auto">
        <h2 className="text-xl font-bold text-gray-800">
          Not what you are looking for ? Try these other offers?
        </h2>
        <div className="mt-5 shadow-lg w-fit px-4 py-2 rounded-xl border-2 bg-white flex items-center flex items-center gap-x-4">
          <div>
            <SignalWifi0BarIcon sx={{ fontSize: 30 }} />
          </div>
          <div className="flex items-center justify-between py-2">
            <div>
              <p className="text-base font-bold leading-4">Home Fibre</p>
              <p className="text-sm font-normal leading-5">
                MTN Fibre Broadband
              </p>
            </div>
            <div className="ml-6 cursor-pointer">
              <ArrowForwardIcon />
            </div>
          </div>
        </div>
      </div> */}
    </BaseLayout>
  );
};

export default ForfaitAccueil;
